module.exports = __webpack_public_path__ + "img/pizza-5.db27b36c.jpg";